interface Filter {
  key: string;
  label: string;
  count?: number;
}

interface Props {
  filters: Filter[];
  value: string[];
  onChange: (next: string[]) => void;
  groupLabel?: string;
}

/**
 * 複数選択（OR 条件）のチップ型フィルタ。
 * 既存 `FilterBar` は単一選択（value: T）の API のため、別コンポーネントとして提供する。
 * 「すべて」チップは選択クリア。各候補チップはクリックでトグル。
 */
export function MultiFilterBar({ filters, value, onChange, groupLabel }: Props) {
  const allActive = value.length === 0;
  const toggle = (key: string) => {
    onChange(value.includes(key) ? value.filter((v) => v !== key) : [...value, key]);
  };
  return (
    <div className="filter-bar">
      {groupLabel && <span className="filter-group-label">{groupLabel}</span>}
      <button
        type="button"
        className={`filter-chip ${allActive ? 'active' : ''}`}
        onClick={() => onChange([])}
      >
        すべて
      </button>
      {filters.map((f) => (
        <button
          key={f.key}
          type="button"
          className={`filter-chip ${value.includes(f.key) ? 'active' : ''}`}
          onClick={() => toggle(f.key)}
        >
          {f.label}
          {f.count !== undefined && <span className="chip-count">{f.count}</span>}
        </button>
      ))}
    </div>
  );
}
